
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/prevention",
      function () {
        return require("private-next-pages/services/prevention.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/prevention"])
      });
    }
  